import { render, staticRenderFns } from "./GloboGraphicsRichTextEditor.vue?vue&type=template&id=12c60386&scoped=true"
import script from "./GloboGraphicsRichTextEditor.vue?vue&type=script&lang=js"
export * from "./GloboGraphicsRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./GloboGraphicsRichTextEditor.vue?vue&type=style&index=0&id=12c60386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c60386",
  null
  
)

export default component.exports